// extracted by mini-css-extract-plugin
module.exports = {"container":"_3aZ6zm","section-title":"fcMrio","winner-title":"_26E0D5","block-download-all":"_2b_1A9","download":"_2j_sWi","MM":"eTHVOx"};